module.exports = __webpack_public_path__ + "static/google_tasks_2-d7baf9b7a7834aa9490e929a2edb4fce.png";